<template>
  <div class="flex flex-row flex-nowrap rounded-md gap-4 p-2">
    <div class="flex flex-col justify-center items-center h-28 w-28 border grow-0 shrink-0 relative">
      <NuxtImg :src="logo" class="max-h-full max-w-full" quality="90" loading="lazy" @error="setDefaultImage" :alt="data.name" :title="data.name"/>
    </div>
    <div class="basis-full flex flex-col gap-0.5 self-center">
      <p class="text-base font-semibold line-clamp-1 break-words">{{ data.name }}</p>
      <p class="text-sm text-gray-500">{{ data.locations[0].address.city }}</p>
      <UDivider class="py-2"/>
      <p class="text-sm text-red-700">Store is closed now. Thank you for your understanding</p>
    </div>
  </div>
</template>
    
<script setup>
  const props = defineProps(['data']);
    
  const logo = useSecureImage(props.data?.images.thumbnail || props.data?.images.gallery[0] || undefined);

  const setDefaultImage = (event) => {
    event.imageSrc = runtimeConfig.public.defaultImage;
  }
</script>